







import store from '@/store';
export default
  name: 'Radio'

  props:
    name:
      type: String
      default: ''
    value:
      type: String
      default: ''
    checked:
      type: Boolean
      default: false
    group:
      type: String
      default: null
    # コントロール配列
    index:
      type: Number
      default: null
    noStore:
      type: Boolean
      default: false

  mounted: () ->
    if @checked
      @_saveStore(@value)

  methods: {
    change: (e) ->
      if e.target.checked
        @$emit('change', e.target.value)
        @_saveStore(e.target.value)
    _saveStore: (value) ->
      if !@noStore
        store.dispatch('setPostParam', {label: @name, value: value, index: @index, group: @group})
  }
